import { Component, OnInit,Input } from '@angular/core';
import { TestQueryService } from './test-query.service';
import { TypeService } from './service/lcontype/type.service';

@Component({
  selector: 'lib-test-query',
  templateUrl: './test-query.component.html',
  styleUrls: []
})
export class TestQueryComponent implements OnInit {
  // 图形类型
  @Input() rootIp:any;
  // 图形高度
  // pHeight:any=1;
  // uls:any;
  // pWidth:any = "100%";
  // ifHeight:any = 0;
  constructor(private ml:TestQueryService,public srv: TypeService,) { 
  }
  // getData:any = {};

  ngOnInit(): void {
    this.srv.number1 = [];
    this.ml.rootIp = this.rootIp;
    // this.ml.setId(this.value[1]);
  }
  ngOnChanges(){
    this.srv.number1 = [];
    this.ml.rootIp = this.rootIp;
    // this.srv.sendrun(this.value[0]);
    // this.getData = {
    //   refresh: this.value.refresh?this.value.refresh:-1,
    //   data:this.value.types,
    //   picheight:this.value.picheight,
    //   newpicData:this.value.newpicData,
    //   dates:this.value.dates,
    //   picDec: this.value.picDec
    // };
    // this.uls = this.ml.createGra(this.value.picIp,this.getData);
  }

}
